// packages/site/src/workers/arch-lsp.worker.ts
//
// Worker module. Boots @archlang/lsp/browser with an in-memory VFS;
// the host sends source via standard LSP `didOpen`/`didChange`. This
// file is bundled by scripts/build-worker.mjs into
// public/workers/arch-lsp.worker.js.

import { startBrowserServer } from "@archlang/lsp/browser";

const vfs = new Map<string, string>();
startBrowserServer(vfs);
